module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "text-center",
    attrs: {
      "id": "mass-suspend"
    }
  }, [_c('h3', [_vm._v("You are about to mass-suspend the below tariffs")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label",
    attrs: {
      "for": "reason-suspend"
    }
  }, [_vm._v("Please enter a reason for the mass-suspension of tariffs")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "reason-suspend"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.confirming) ? _c('div', {
    class: [_vm.isValid ? '' : 'disabled', 'btn btn-danger'],
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n    Confirm mass-suspension\n  ")]) : _vm._e(), _vm._v(" "), (_vm.confirming) ? _c('div', [_c('h5', [_vm._v("\n      Are you sure?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.update
    }
  }, [_vm._v("\n      Confirm\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.confirming = false
      }
    }
  }, [_vm._v("\n      Cancel\n    ")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-182ad421"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Tariff/MassSuspend.vue
// module id = 2104
// module chunks = 1